var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[(_vm.$slots.hasOwnProperty('image'))?_c('div',{class:_vm.$style.image},[_vm._t("image")],2):_vm._e(),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }